import { render, staticRenderFns } from "./VModalTransfer.vue?vue&type=template&id=0138ea62&scoped=true&"
import script from "./VModalTransfer.vue?vue&type=script&lang=js&"
export * from "./VModalTransfer.vue?vue&type=script&lang=js&"
import style0 from "./VModalTransfer.vue?vue&type=style&index=0&id=0138ea62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0138ea62",
  null
  
)

export default component.exports